/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_appsync_graphqlEndpoint": "https://ihjucobqr5etnmys5i4uodif6u.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-b6yiwhhj6veuxdj67qrboguovm",
    "aws_cognito_identity_pool_id": "ap-southeast-1:b1007f4c-1102-4737-88e2-b83edab6709e",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_yR9fNhfKK",
    "aws_user_pools_web_client_id": "1he2eeormri2phltjiigvpov44",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-southeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "User-ed6szwo6jfafbhwz7f57mezws4-test",
            "region": "ap-southeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "acegroup-webdam",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
